/**
 * @generated SignedSource<<46aeca1be75ff057fc2e26dd3380b565>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type setDirectFeedbackFlowConfigForm_TreeNodeFragment$data = {
  readonly id: string;
  readonly " $fragmentType": "setDirectFeedbackFlowConfigForm_TreeNodeFragment";
};
export type setDirectFeedbackFlowConfigForm_TreeNodeFragment$key = {
  readonly " $data"?: setDirectFeedbackFlowConfigForm_TreeNodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"setDirectFeedbackFlowConfigForm_TreeNodeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "setDirectFeedbackFlowConfigForm_TreeNodeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "TreeNode",
  "abstractKey": null
};

(node as any).hash = "ff49d7459c50653698726babcfa2bb36";

export default node;
